/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum DynamicFlag {
    ZERO = 'zero',
    ONE = 'one',
    TWO = 'two',
    THREE = 'three',
    FOUR = 'four',
    FIVE = 'five',
    SIX = 'six',
    SEVEN = 'seven'
}


export function instanceOfDynamicFlag(value: any): boolean {
    for (const key in DynamicFlag) {
        if (Object.prototype.hasOwnProperty.call(DynamicFlag, key)) {
            if (DynamicFlag[key as keyof typeof DynamicFlag] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DynamicFlagFromJSON(json: any): DynamicFlag {
    return DynamicFlagFromJSONTyped(json, false);
}

export function DynamicFlagFromJSONTyped(json: any, ignoreDiscriminator: boolean): DynamicFlag {
    return json as DynamicFlag;
}

export function DynamicFlagToJSON(value?: DynamicFlag | null): any {
    return value as any;
}

export function DynamicFlagToJSONTyped(value: any, ignoreDiscriminator: boolean): DynamicFlag {
    return value as DynamicFlag;
}

